import instance from '@/http';

export default {
	saveDispatchersStatement(date, dispatchers) {
		return instance().post("dispatcher/statement", {
			date: date,
			dispatchers: dispatchers
		}).then(resp => resp).catch(error => error);
	},
};
